import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, put } from '../api/client.js';

const KEY = ['me', 'banking'];

export function useBanking() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => (await get('/api/me/banking')).banking || {},
    staleTime: 5 * 60_000,
  });
}

export function useUpdateBanking() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => put('/api/me/banking', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
